import {Routes} from "@angular/router";
import {SubmissionComponent} from "./submission/submission.component";

export enum LegalRoutes {
  Submission = 'submission'
}

export const MAILING_LEGAL_ROUTES: Routes = [
  {
    path: LegalRoutes.Submission,
    component: SubmissionComponent
  },
  {
    path: '**', redirectTo: '/', pathMatch: 'full'
  }
]
